module.exports = __webpack_public_path__ + "static/img/02.1c0b562.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8/02.jpg
// module id = f7v7
// module chunks = 1